export { buildLandCoverReport } from '../utils/landCoverPdfReport';

/**
 * EUSCoast's entry point for the PDF report.
 * The report itself is built by {@link module:LAND_COVER_PDF_REPORT}, shared with the other
 * coastal squeeze module because the two run the same analysis over different land cover
 * collections. What cannot be shared is which module a report belongs to: the key names the
 * downloaded file and decides which page's button the export registers on, so it lives here,
 * beside the module it identifies, rather than in the shared builder.
 */

/**
 * @constant REPORT_MODULE
 * @description Module key, used to name the file and to register the export.
 * @memberof module:Euscoast
 */
export const REPORT_MODULE = 'euscoast';
